/**
 * 订单 / 充值服务：充值下单、套餐下单、订单列表、USDT 交易哈希确认。
 *
 * @module services/order
 */
import type { Order, Paginated, PaymentMethod } from '@/types';
import { API } from '@/config/api';
import { request } from './http';

/** 充值下单入参。 */
export interface RechargeInput {
  amount: string | number;
  paymentMethod: PaymentMethod;
}

/** 套餐下单入参。 */
export interface PackageOrderInput {
  packageId: number;
  paymentMethod: PaymentMethod;
}

/** 分页查询订单入参。 */
export interface OrderQuery {
  page?: number;
  pageSize?: number;
}

/** 创建充值订单。 */
export async function createRecharge(input: RechargeInput): Promise<Order> {
  return request<Order>({
    method: 'POST',
    url: API.order.recharge,
    data: input,
  });
}

/** 创建套餐购买订单。 */
export async function createPackageOrder(
  input: PackageOrderInput,
): Promise<Order> {
  return request<Order>({
    method: 'POST',
    url: API.order.package,
    data: input,
  });
}

/** 分页查询订单。 */
export async function listOrders(
  query: OrderQuery = {},
): Promise<Paginated<Order>> {
  return request<Paginated<Order>>({
    method: 'GET',
    url: API.order.list,
    params: query,
  });
}

/** 提交 USDT 交易哈希确认。 */
export async function submitUsdtTxHash(
  orderNo: string,
  txHash: string,
): Promise<Order> {
  return request<Order>({
    method: 'POST',
    url: API.order.usdtConfirm(orderNo),
    data: { txHash },
  });
}
